import { v4 as uuidv4 } from 'uuid';
import { deriveDirectoryFilterIndustries } from './getDirectoryPublishers';

function doesNotMatchWhatsHot(whatshotEnabled, publisher, whatsHotPublisherIds) {
    if (!whatshotEnabled) return false;
    return !whatsHotPublisherIds[String(publisher.pubId)];
}

function doesNotMatchIndustryFilters(industryFilters, publisher) {
    if (!industryFilters.length) return false;
    return !industryFilters.some((category) => publisher.industries?.includes(category));
}

// Text matching itself is server-side now (EBL-13117) — searchDirectoryPublishers()
// already sent `search` to the API, so the pool switches to its results
// rather than re-filtering by name client-side.
function applyDirectoryFilter() {
    const { searchText, whatshotEnabled, industryFilters } = this.search;
    const searchActive = !!searchText.trim();
    const pool = searchActive ? this.searchDirectoryResults : this.directoryPublishers;

    this.filteredDirectoryPublishers = pool.filter((publisher) => {
        if (doesNotMatchWhatsHot(whatshotEnabled, publisher, this.whatsHotPublisherIds)) return false;
        if (doesNotMatchIndustryFilters(industryFilters, publisher)) return false;
        return true;
    });

    // Pills must reflect whichever pool is actually active — without this,
    // clearing the search box left the pill list showing only the narrow
    // industry set from the last search's results, out of sync with the
    // full browse list now displayed.
    this.directoryFilterIndustries = deriveDirectoryFilterIndustries(pool);

    this.observed.filteredDirectoryPublishers = uuidv4();
}

export default applyDirectoryFilter;
